export function createUIService(helium) {
	const modalsChannel = helium.factory('ui:modals', { active: null });
	const sidebarChannel = helium.factory('ui:sidebar', { collapsed: false });
	
	const openModal = (modalName, data = null) => {
		modalsChannel.send(modals => ({ ...modals, active: modalName, data }));
	};
	
	const closeModal = () => {
		modalsChannel.send(modals => ({ ...modals, active: null, data: null }));
	};
	
	const toggleSidebar = () => {
		sidebarChannel.send(sidebar => ({ ...sidebar, collapsed: !sidebar.collapsed }));
	};
	
	return { modalsChannel, sidebarChannel, openModal, closeModal, toggleSidebar };
}
